<script setup>
const emit = defineEmits(['close', 'success'])

const user = useUser()
const ui = useUi()
const tech = useTech()

const { AnalyticsEvent, track } = useAnalytics()

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  },
  email: {
    type: String,
    required: true
  }
})

const loading = ref(false)

const form = reactive({
  name: '',
  password: '',
  email: ''
})

async function submit () {
  loading.value = true

  const [firstName, ...lastNameArray] = form.name.split(' ')
  const lastName = lastNameArray.join(' ')

  try {
    await user.register({
      email: props.email || form.email,
      password: form.password,
      last_name: lastName,
      first_name: firstName
    })

    emit('success')

    track(AnalyticsEvent.SIGNUP, {
      provider: 'email',
      name: `${firstName ?? ''} ${lastName ?? ''}`,
      email: props.email || form.email
    })
  } catch (e) {
    ui.showErrorModal(e)
    loading.value = false
  }
}
</script>

<template>
  <AppModal
    :is-open="isOpen"
    @close="$emit('close')">
    <div class="relative flex flex-col gap-6 rounded-3xl bg-white px-4 py-6 md:w-130 md:p-9 dark:bg-dark-gunmetal">
      <AppCloseButton @close="$emit('close')" />

      <h1 class="heading-primary text-3xl font-bold md:text-5xl">
        <em>Almost there!</em>
      </h1>

      <form
        class="flex w-full flex-col gap-6"
        @submit.prevent="submit">
        <FormInput
          v-if="!email"
          v-model="form.email"
          required
          type="text"
          label="Your Email"
          placeholder="Enter your email" />
        <FormInput
          v-model="form.name"
          required
          type="text"
          label="Your Full Name"
          placeholder="Enter your full name" />
        <FormInput
          ref="inputPassword"
          v-model="form.password"
          required
          type="password"
          placeholder="Enter your password"
          label="Choose Your Password" />

        <div class="text-center text-sm text-body-gray">
          <span>
            By creating this account you agreed with our
          </span>
          <NuxtLink
            :to="`/${tech.id}/legal/terms-conditions`"
            target="_blank"
            class="underline">
            Terms & Conditions
          </NuxtLink>
        </div>

        <button
          :disabled="loading"
          class="btn-primary w-full px-8 py-4">
          <AppLoading v-if="loading" /> Sign Up
        </button>
      </form>
    </div>
  </AppModal>
</template>
